(() => {
  const root = document.querySelector('[data-jp-member-welcome]');
  if (!root) return;

  /*
   * Primary copy library: exactly 50 messages per time-of-day category.
   * Add future seasonal or event contexts beneath `contextual` so copy stays
   * centralized without changing the selection and deck logic.
   */
  const messageLibrary = {
    morning: [
      'Starting the day with a little perfume browsing?',
      'Something beautiful for your morning.',
      'Your perfume wardrobe is waiting.',
      'Come see what is calling your name today.',
      'A soft start and a beautiful scent.',
      'Begin gently. The perfumes can wait with you.',
      'Morning light pairs nicely with fragrance daydreaming.',
      'What kind of scent suits today?',
      'A fresh day deserves a curious nose.',
      "Take your time choosing today's mood.",
      'Perhaps the morning needs a little more beauty.',
      'Scent is a lovely way to begin.',
      'Start with something light, lovely, and entirely yours.',
      'A quiet browse before the day gets busy.',
      'Let the morning unfold one note at a time.',
      'Today feels ready for a beautiful fragrance story.',
      'A little perfume wandering before the day begins?',
      'Find the note that brightens your morning.',
      'Fresh possibilities, bottled beautifully.',
      'Your morning ritual just became more fragrant.',
      'Consider this a gentle start to something lovely.',
      'There is always room for a beautiful beginning.',
      'A calm morning calls for thoughtful browsing.',
      'Which fragrance mood are we choosing today?',
      'The day is young. Wander a little.',
      'A bright beginning, with a touch of perfume.',
      'Let curiosity lead your morning browse.',
      'Something delicate might be perfect right now.',
      'The best mornings leave room for discovery.',
      'Pause here before the day carries you away.',
      'A beautiful scent can set the whole tone.',
      'Ease into the day with something luminous.',
      'A fresh chapter begins with a favorite note.',
      'This morning has excellent perfume potential.',
      'Start slowly. Beauty is not in a hurry.',
      'A little fragrance inspiration for the day ahead.',
      'Find something that feels like morning light.',
      'Your next scent mood may be waiting here.',
      'The morning feels softer with perfume nearby.',
      'Browse gently. There is plenty of day ahead.',
      'A graceful beginning starts with curiosity.',
      "Let today's fragrance mood find you.",
      'Morning is a lovely time to wander.',
      'A quiet fragrance moment, just for you.',
      'Choose a note to carry into the day.',
      'The perfume shelves are glowing softly this morning.',
      'Something beautiful may catch your attention today.',
      'Begin with wonder and follow the notes.',
      'A lovely day can start right here.',
      'Good mornings deserve beautiful possibilities.',
    ],
    afternoon: [
      'A little scent break?',
      'Let us see what is calling your name today.',
      'Welcome back to your fragrance wardrobe.',
      'A little perfume escape?',
      'Pause the day for something beautiful.',
      'A small perfume escape sounds nice right now.',
      'Let curiosity take the afternoon shift.',
      'What might catch your attention today?',
      'A fragrant pause can change the whole afternoon.',
      'Step away for a little scent wandering.',
      'The afternoon could use a softer moment.',
      'Browse slowly. The day can wait a minute.',
      'A beautiful distraction, perfectly timed.',
      'Let the afternoon drift somewhere more fragrant.',
      'Your next scent mood may be right here.',
      'Take five for a little perfume daydreaming.',
      'A quiet browse between everything else.',
      'Something lovely for the middle of the day.',
      'A graceful pause looks good on you.',
      'Follow whichever note feels interesting today.',
      'The day feels lighter with a perfume interlude.',
      'Consider this your fragrant little recess.',
      'A moment of beauty belongs in every afternoon.',
      'See where your curiosity takes you.',
      'The perfect time for a scent detour.',
      'A little wandering may be exactly right.',
      'Let the perfumes interrupt the ordinary.',
      'Find a fragrance mood for the rest of today.',
      'The afternoon is open to beautiful possibilities.',
      'A soft escape is only a browse away.',
      'Something intriguing might brighten the day.',
      'Take the scenic route through the perfume shelves.',
      'A lovely pause, with notes of possibility.',
      'This moment could use a little fragrance.',
      'Browse by instinct. It usually knows something.',
      'A scent break feels especially well timed.',
      'Let something beautiful hold your attention.',
      'The afternoon invites a little exploration.',
      'Find a note that changes the mood.',
      'A small luxury for an ordinary afternoon.',
      'There is time for one beautiful detour.',
      'A little perfume curiosity goes a long way.',
      'Give the day a more fragrant middle.',
      'Wander until something feels just right.',
      'The perfume wardrobe is open for browsing.',
      'A quiet discovery could be waiting here.',
      'Take a breath and browse beautifully.',
      'The rest of the day can begin softly.',
      'Something elegant might be calling your attention.',
      'A pleasant pause starts with a curious glance.',
    ],
    evening: [
      'Perfect time for a little perfume window shopping.',
      'Let us find something beautiful tonight.',
      'A little evening perfume browsing?',
      'The evening feels better with a little fragrance browsing.',
      'Settle in and follow the beautiful notes.',
      'Tonight is made for unhurried perfume wandering.',
      'Let the day end somewhere fragrant.',
      'A softer evening begins with a beautiful scent.',
      'Dim the lights. Keep the perfume possibilities open.',
      'A little luxury belongs at the end of the day.',
      'The evening is yours to browse slowly.',
      'Find something that feels lovely after dark.',
      'Perfume window shopping suits this hour.',
      'Let the night begin on a beautiful note.',
      'A quiet evening calls for a fragrant escape.',
      'Browse as slowly as the evening deserves.',
      'Something warm and beautiful may catch your eye.',
      'The day is winding down. The notes are not.',
      'Tonight feels right for a little scent discovery.',
      'A calm evening and a curious nose.',
      'Take the long way through the perfume wardrobe.',
      'Let fragrance soften the edges of the day.',
      'An elegant little escape for the evening.',
      'See what feels beautiful tonight.',
      'The perfume shelves look especially inviting after hours.',
      'Evening browsing has a charm of its own.',
      'Follow the notes that feel most like tonight.',
      'A lovely scent mood could complete the evening.',
      'Unwind with something beautiful and quietly fragrant.',
      'Consider this your evening fragrance interlude.',
      'The night has room for a little wonder.',
      'Set the evening to something softly scented.',
      'A beautiful browse before the day is done.',
      'Find the note that matches the mood.',
      "Tonight's possibilities are best explored slowly.",
      'A gentle perfume detour before you settle in.',
      'The evening invites a more luxurious pace.',
      'Let something luminous catch your attention.',
      'A little fragrance daydreaming fits the evening perfectly.',
      'End the day with curiosity, not hurry.',
      'The loveliest evenings leave room for discovery.',
      'Browse quietly. Something beautiful may find you.',
      'A polished little pause for the evening.',
      'Let the perfume wardrobe set the atmosphere.',
      'Tonight could use one more beautiful detail.',
      'A soft glow and a world of notes.',
      'This hour was made for fragrance wandering.',
      'Find something that lingers in your imagination.',
      'Evening has its own kind of perfume magic.',
      'Stay awhile. The fragrance mood is just right.',
    ],
    lateNight: [
      'We support late-night perfume decisions.',
      'Still browsing? No judgment here.',
      'Apparently perfume shopping has no bedtime.',
      'A little midnight perfume browsing?',
      'Sleep can wait for one beautiful note.',
      'The perfumes are keeping excellent late-night company.',
      'Nothing wrong with a little after-hours fragrance wandering.',
      'This is a very reasonable midnight activity.',
      'The night is quiet. The perfume possibilities are not.',
      'One more scent browse, then perhaps bedtime.',
      'Late-night curiosity has excellent taste.',
      'The moon approves of this fragrance detour.',
      'Some decisions are better made after dark.',
      'A quiet hour for beautifully unquiet ideas.',
      'Perfume thoughts do tend to ignore bedtime.',
      'The fragrance wardrobe is still awake too.',
      'Midnight is surprisingly good for scent daydreams.',
      'No rush. The night has nowhere else to be.',
      'A little nocturnal perfume wandering feels appropriate.',
      'The best kind of bedtime procrastination.',
      'One last look can be wonderfully fragrant.',
      'The night shift at the perfume wardrobe begins.',
      'Browsing softly while the world is quiet.',
      'Apparently inspiration prefers the late hours.',
      'The hour is late. Your taste remains impeccable.',
      'Moonlight and perfume browsing make charming companions.',
      'Consider this a very elegant night owl moment.',
      'A beautiful scent thought before sleep?',
      'The perfume possibilities look different after midnight.',
      'Stay curious. Bedtime will understand.',
      'The night is young enough for one more browse.',
      'Quiet hours, interesting notes, excellent priorities.',
      'A little fragrance intrigue for the sleepless mind.',
      'Perhaps the perfect scent idea arrives late.',
      'This perfume detour is between us and the moon.',
      'The lights are low. Curiosity is wide awake.',
      'After-hours browsing has a certain elegance.',
      'The fragrance wardrobe does not keep office hours.',
      "A midnight browse never hurt anyone's beauty sleep.",
      'Let the night lead you somewhere fragrant.',
      'Sleepy eyes, excellent scent instincts.',
      'The quiet makes every beautiful possibility feel closer.',
      'There is always time for one more note.',
      "Tonight's perfume thoughts are clearly not finished.",
      'A polished little distraction before dreams.',
      'The moon is up. So is your curiosity.',
      'Late-night fragrance wandering suits you rather well.',
      'The hour says sleep. The perfume shelf says browse.',
      'A soft little scent search before lights out.',
      'We can call this research and go with it.',
    ],
    contextual: {
      friday: [
        'A little end-of-week perfume browsing?',
        'Consider this permission to treat yourself.',
        'Friday-night fragrance wandering feels appropriate.',
      ],
      saturday: [
        'Take your time. You have perfumes to smell.',
        'Come wander through something beautiful.',
        'A quiet little fragrance escape?',
      ],
      sunday: [
        'A quiet little fragrance moment?',
        'Come wander through something beautiful.',
        'Something soft and beautiful for your Sunday.',
      ],
      returningLong: [
        'It has been a little while. Come see what you have missed.',
        'Your fragrance wardrobe is very happy to see you.',
        'Come see what has been waiting for you.',
      ],
      returningSoon: [
        'Back for another look?',
        'Nice to see you again.',
        'Something still calling your name?',
      ],
    },
  };

  const eyebrows = {
    morning: 'Good morning \u2600\uFE0F',
    afternoon: 'Good afternoon \u2728',
    evening: 'Good evening \uD83C\uDF19',
    lateNight: 'Up late? \uD83C\uDF19',
    friday: 'Happy Friday \u2728',
    saturday: 'Happy Saturday \u2728',
    sunday: 'Slow Sunday \u2728',
    returningLong: 'It has been a little while \u2726',
    returningSoon: 'A familiar face \u2726',
  };

  const isMember = root.dataset.isMember === 'true';
  const hasAccount = root.dataset.hasAccount === 'true';
  const customerKey = root.dataset.customerKey || 'guest';
  const firstName = hasAccount ? (root.dataset.firstName || '').trim() : '';
  const storageKeys = {
    lastVisit: `jpWelcome:lastVisit:${customerKey}`,
    lastMessage: `jpWelcome:lastMessage:${customerKey}`,
    deck: (context) => `jpWelcome:messageDeck:v1:${customerKey}:${context}`,
    sessionSelection: `jpWelcome:sessionSelection:v1:${customerKey}`,
  };

  const getStored = (storage, key) => {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  };

  const setStored = (storage, key, value) => {
    try {
      storage.setItem(key, value);
      return true;
    } catch (error) {
      return false;
    }
  };

  const localStorageAvailable = (() => {
    const testKey = `jpWelcome:storageTest:${Date.now()}`;
    try {
      window.localStorage.setItem(testKey, '1');
      window.localStorage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  })();

  const sessionStorageAvailable = (() => {
    const testKey = `jpWelcome:sessionStorageTest:${Date.now()}`;
    try {
      window.sessionStorage.setItem(testKey, '1');
      window.sessionStorage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  })();

  const timeContext = (hour) => {
    if (hour >= 5 && hour < 12) return 'morning';
    if (hour >= 12 && hour < 17) return 'afternoon';
    if (hour >= 17 && hour < 22) return 'evening';
    return 'lateNight';
  };

  const chooseContext = (now, previousVisit) => {
    const ordinaryContext = timeContext(now.getHours());
    const elapsedDays = previousVisit ? (now.getTime() - previousVisit) / 86400000 : null;

    /* Priority remains: longer absence, late night, weekend, recent return, ordinary time. */
    if (elapsedDays !== null && elapsedDays >= 21) return 'returningLong';
    if (ordinaryContext === 'lateNight') return 'lateNight';

    const weekendContext = { 0: 'sunday', 5: 'friday', 6: 'saturday' }[now.getDay()];
    if (weekendContext && Math.random() < 0.55) return weekendContext;

    if (elapsedDays !== null && elapsedDays >= 0.08 && elapsedDays < 7 && Math.random() < 0.25) {
      return 'returningSoon';
    }

    return ordinaryContext;
  };

  const messagesForContext = (context) =>
    messageLibrary[context] || messageLibrary.contextual[context] || messageLibrary.evening;

  const shuffle = (messages) => {
    const shuffled = [...messages];
    for (let index = shuffled.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      [shuffled[index], shuffled[randomIndex]] = [shuffled[randomIndex], shuffled[index]];
    }
    return shuffled;
  };

  const moveImmediateRepeat = (deck, previousMessage) => {
    if (!previousMessage || deck.length < 2 || deck[0] !== previousMessage) return deck;
    const nextDifferentIndex = deck.findIndex((message) => message !== previousMessage);
    if (nextDifferentIndex > 0) {
      [deck[0], deck[nextDifferentIndex]] = [deck[nextDifferentIndex], deck[0]];
    }
    return deck;
  };

  const randomWithoutImmediateRepeat = (options, previousMessage) => {
    const freshOptions = options.filter((message) => message !== previousMessage);
    const pool = freshOptions.length ? freshOptions : options;
    return pool[Math.floor(Math.random() * pool.length)];
  };

  const chooseMessage = (context) => {
    const options = messagesForContext(context);
    const previousMessage = localStorageAvailable
      ? getStored(window.localStorage, storageKeys.lastMessage)
      : window.__jpWelcomeLastMessage || null;

    if (!localStorageAvailable) {
      const fallbackMessage = randomWithoutImmediateRepeat(options, previousMessage);
      window.__jpWelcomeLastMessage = fallbackMessage;
      return fallbackMessage;
    }

    let deck = [];
    const storedDeck = getStored(window.localStorage, storageKeys.deck(context));
    if (storedDeck) {
      try {
        const parsedDeck = JSON.parse(storedDeck);
        if (Array.isArray(parsedDeck)) {
          deck = parsedDeck.filter(
            (message, index) => options.includes(message) && parsedDeck.indexOf(message) === index,
          );
        }
      } catch (error) {
        deck = [];
      }
    }

    if (!deck.length) deck = shuffle(options);
    moveImmediateRepeat(deck, previousMessage);

    const selectedMessage = deck.shift();
    setStored(window.localStorage, storageKeys.deck(context), JSON.stringify(deck));
    setStored(window.localStorage, storageKeys.lastMessage, selectedMessage);
    return selectedMessage;
  };

  const getSessionSelection = () => {
    const storedSelection = sessionStorageAvailable
      ? getStored(window.sessionStorage, storageKeys.sessionSelection)
      : window.__jpWelcomeSessionSelections?.[customerKey];

    if (!storedSelection) return null;

    try {
      const parsedSelection = typeof storedSelection === 'string'
        ? JSON.parse(storedSelection)
        : storedSelection;
      const options = messageLibrary[parsedSelection.context]
        || messageLibrary.contextual[parsedSelection.context];

      if (
        typeof parsedSelection.context === 'string'
        && typeof parsedSelection.message === 'string'
        && Array.isArray(options)
        && options.includes(parsedSelection.message)
      ) {
        return parsedSelection;
      }
    } catch (error) {
      return null;
    }

    return null;
  };

  const setSessionSelection = (selection) => {
    if (sessionStorageAvailable) {
      setStored(window.sessionStorage, storageKeys.sessionSelection, JSON.stringify(selection));
      return;
    }

    window.__jpWelcomeSessionSelections = window.__jpWelcomeSessionSelections || {};
    window.__jpWelcomeSessionSelections[customerKey] = selection;
  };

  const render = (selection) => {
    const eyebrow = root.querySelector('[data-jp-welcome-eyebrow]');
    const prefix = root.querySelector('[data-jp-welcome-prefix]');
    const name = root.querySelector('[data-jp-welcome-name]');
    const message = root.querySelector('[data-jp-welcome-message]');

    if (eyebrow) eyebrow.textContent = selection.eyebrow;
    if (prefix) prefix.textContent = hasAccount ? (firstName ? 'Welcome back, ' : 'Welcome back') : 'Welcome';
    if (name) name.textContent = hasAccount ? firstName : '';
    if (message) message.textContent = selection.message;
  };

  /* Consume one deck card per tab session, then reuse it on every later page load. */
  const now = new Date();
  const storedVisit = Number(getStored(window.localStorage, storageKeys.lastVisit));
  const previousVisit = Number.isFinite(storedVisit) && storedVisit > 0 ? storedVisit : null;
  let selection = getSessionSelection();

  if (!selection) {
    const context = chooseContext(now, previousVisit);
    selection = {
      context,
      message: chooseMessage(context),
    };
    setSessionSelection(selection);
  }

  selection.eyebrow = eyebrows[selection.context] || eyebrows.evening;

  setStored(window.localStorage, storageKeys.lastVisit, String(now.getTime()));
  render(selection);
})();
